import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn 约定的 className 合并工具 (clsx + tailwind-merge)。 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 延迟格式化: 毫秒过大时(≥1s)以秒展示更直观, 小值保留 ms。
 * 例: 84462 → "84.5 s"、523 → "523 ms"、0/负/非有限 → "0 ms"。
 */
export function formatLatency(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return '0 ms'
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)} s`
  return `${Math.round(ms)} ms`
}
